import { MdCancel } from 'react-icons/md';
import { AudienceInsightsDimensions } from '@blisspointmedia/bpm-types/dist/YoutubePlanning';
import { IconButton } from '@Components/IconButton';
import { Appearance, Design, Size } from '@Components/designConstants';
import { AudienceInsightMenuItem } from './youtube-planning-types';

interface SegmentProps {
  segment: AudienceInsightMenuItem;
  editMode: boolean;
  onDelete: (dimension: AudienceInsightsDimensions, id: string) => void;
}

export const Segment = ({ segment, editMode, onDelete }: SegmentProps) => (
  <div className='segment'>
    <div className='segment-label'>{segment.label}</div>
    {editMode && (
      <IconButton
        className='delete-icon'
        appearance={Appearance.EMPTY}
        design={Design.NEUTRAL}
        size={Size.SM}
        onClick={() => onDelete(segment.dimension as AudienceInsightsDimensions, segment.value)}
      >
        <MdCancel />
      </IconButton>
    )}
  </div>
);
